import React from 'react';
import { OrderDate } from 'src/constrains/AdvancedFilters/Components';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { IntClear } from '../Components';
const _OrderDate = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    root,
    form,
    selectName,
    daysName,
    policyName,
    singleDayName,
    dayRangeName,
    state,
    disabled,
  } = props;
  return (
    <SectionWrapper title={getI18n('customerList.advancedFilter.orderdate')}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper title=''>
                <OrderDate
                  selectName={selectName}
                  policyName={policyName}
                  daysName={daysName}
                  singleDayName={singleDayName}
                  dayRangeName={dayRangeName}
                  disabled={disabled}
                />
                <IntClear
                  form={form}
                  root={root}
                  value={selectName}
                  state={state}
                  disabled={disabled}
                />
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
    </SectionWrapper>
  );
};
export default _OrderDate;
